import { LoadingButton } from '@mui/lab'
import { Stack } from '@mui/material'
import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useBoolean } from 'react-use'

import { TestEvaluationResultsStatusCheckIntegration } from 'components/services/create/TestEvaluationResultsStatusCheckIntegration'
import {
  buildEvaluationConfigurationFromFormValues,
  buildTeamExternalIntegration,
  StatusCheckFormValues
} from 'components/status-checks/status-checks-form-utils'
import useAuth from 'hooks/use-auth'
import { useTranslation } from 'hooks/use-translation'
import toast from 'lib/toast'
import { EvaluationResults } from 'types/api/status-checks/evaluation'
import { EndpointResponse } from 'types/api/status-checks/status-check'
import { testStatusCheckEvaluation } from 'utils/team-external-integrations/team-external-integrations-util'

export const TestStatusCheckSuccessEvaluation: React.FC<{
  disabled?: boolean
  endpointResponse: EndpointResponse
  onChanged: (isEvaluationChecked: boolean) => void
}> = ({ disabled = false, endpointResponse, onChanged }) => {
  const { currentTeamId } = useAuth()
  const { trans } = useTranslation()

  const [isLoading, setIsLoading] = useBoolean(false)
  const [evaluationResults, setEvaluationResults] =
    useState<EvaluationResults>()

  const { getValues } = useFormContext<StatusCheckFormValues>()

  return (
    <Stack>
      <LoadingButton
        color="primary"
        data-testid="test-evaluation-status-check-integration-button"
        disabled={disabled}
        loading={isLoading}
        size="small"
        sx={{ marginBottom: 2, width: 'fit-content' }}
        variant="contained"
        onClick={async () => {
          setIsLoading(true)
          await testStatusCheckEvaluation(
            buildEvaluationConfigurationFromFormValues(getValues()),
            endpointResponse,
            currentTeamId,
            buildTeamExternalIntegration(getValues()),
            (evaluationResults) => {
              setIsLoading(false)
              setEvaluationResults(evaluationResults)
              onChanged(true)
            },
            (err) => {
              setIsLoading(false)
              onChanged(false)
              toast({ type: 'error', text: err?.message })
            }
          )
        }}
      >
        {trans('forms.buttons.test_evaluation.label')}
      </LoadingButton>
      {!isLoading && evaluationResults && (
        <TestEvaluationResultsStatusCheckIntegration
          endpointResponse={endpointResponse}
          evaluationResults={evaluationResults}
          integration={null}
        />
      )}
    </Stack>
  )
}
